import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=3dcdd0ac&"
import script from "./NotFound.vue?vue&type=script&lang=ts&"
export * from "./NotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import ErrorPage from '@cnamts/vue-dot/src/templates/ErrorPage'
installComponents(component, {ErrorPage})
